export class Roles {
  // Individual roles
  static COORDINATOR = 'cvv_coordinator';
  static DRIVER = 'cvv_driver';
  static VIEW_ONLY = 'cvv_view_only';

  // Role groups (customize these for convenience)
  static GENERAL_APP_ACCESS = [ Roles.COORDINATOR, Roles.DRIVER, Roles.VIEW_ONLY ];
}
